export {
  getConfiguration,
  generateModulesProviderAsync,
  resolveModuleAsync,
  resolveExtraBuildDependenciesAsync,
} from './apple';
